import { render, staticRenderFns } from "./quickorderResumenListado_child.vue?vue&type=template&id=42e6fd40&scoped=true"
import script from "./quickorderResumenListado_child.vue?vue&type=script&lang=js"
export * from "./quickorderResumenListado_child.vue?vue&type=script&lang=js"
import style0 from "./quickorderResumenListado_child.vue?vue&type=style&index=0&id=42e6fd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6fd40",
  null
  
)

export default component.exports